export const recipeIngredientDtoFields = [{
        name: "clfIngredientTypeDescription",
        title: "Ingrediente",
        render: (record) => record.clfIngredientTypeDescription
    }, {
        name: "quantity",
        title: "Percentuale",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => record.recipeIngredient.quantity.toFixed(0) + " %"
    }];
